import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'

var config = {
  apiKey: "AIzaSyBK9aEJOhly6NExr69mAYrVFFgi4EOdzMw",
  authDomain: "alfath-belajar.firebaseapp.com",
  databaseURL: "https://alfath-belajar-default-rtdb.firebaseio.com",
  projectId: "alfath-belajar",
  storageBucket: "alfath-belajar.appspot.com",
  messagingSenderId: "136367425425",
  appId: "1:136367425425:web:1d621177ef2a395e7efc30",
  measurementId: "G-MM7XSE81T5"
};

if(firebase.apps) {
  if(firebase.apps.length) {

  } else {
    firebase.initializeApp(config)
  }
} else {
  firebase.initializeApp(config)
}

export const GoogleProvider = new firebase.auth.GoogleAuthProvider();
export const auth = firebase.auth();
export const DB = firebase.database();
export default firebase